// src/theme/styledTheme.js

export const styledTheme = {
    colors: {
      primary: "#0B2A4A",
      secondary: "#4F46E5",
      accent: "#2FE4FF",
      background: "#F7FAFF",
      text: "#0B1220",
      textLight: "#425466",
    },
  };
  